import update from 'immutability-helper';
import { CLEAR_ERROR, CLEAR_SUCCESS, SHOW_ERROR, SHOW_SUCCESS } from './snackbars-actions';

const initialState = {
  errorMessage: null,
  // showError: false, todo: use this to hide
  successMessage: null
};

function snackbarsReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_SUCCESS:
      return update(state, {
        successMessage: {$set: action.payload}
      });
    case SHOW_ERROR:
      return update(state, {
        errorMessage: {$set: action.payload}
      });
    case CLEAR_ERROR:
      return update(state, {
        errorMessage: {$set: null}
      });
    case CLEAR_SUCCESS:
      return update(state, {
        successMessage: {$set: null}
      });
    default:
      return state
  }
}

export default snackbarsReducer;



// WEBPACK FOOTER //
// ./src/components/snackbars/snackbars-reducer.js